import { FormInput } from "@general-backoffice/core";
import type { TaxProfile } from "@investhinks/api-client";
import React, { useMemo } from "react";
import { Alert } from "reactstrap";

import { buildIrpfRateOptions } from "../taxProfileConstants";

type IRPFStepTaxProfile = Pick<TaxProfile, "irpfRate" | "altaDate"> & Record<string, unknown>;

interface IRPFStepProps {
  taxProfile: IRPFStepTaxProfile | null;
  handleInputChange: (name: string, value: unknown) => void;
  handleInputEvent: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isLoading: boolean;
  t: (key: string, fallback?: string) => string;
}

const IRPFStep = ({ taxProfile, handleInputChange, handleInputEvent, isLoading, t }: IRPFStepProps) => {
  const irpfOptions = useMemo(() => buildIrpfRateOptions(t), [t]);

  const selectedRate = irpfOptions.find((o) => o.value === taxProfile?.irpfRate);

  return (
    <div>
      <h5 className="mb-3">{t("steps.irpf.title", "IRPF Withholding")}</h5>
      <p className="text-muted mb-4">{t("steps.irpf.description", "Select your applicable IRPF withholding rate.")}</p>

      <FormInput.Select
        label={t("steps.irpf.rateLabel", "IRPF Rate")}
        name="irpfRate"
        value={selectedRate}
        options={irpfOptions}
        onChange={({ value }) => handleInputChange("irpfRate", value)}
        isDisabled={isLoading}
      />

      {taxProfile?.irpfRate === 0.07 && (
        <>
          <Alert color="info" className="mt-3">
            <i className="fas fa-info-circle mr-2" />
            {t(
              "steps.irpf.newAutonomoInfo",
              "The 7% rate applies to new autónomos in their first 3 years of activity."
            )}
          </Alert>

          <FormInput.Input
            type="date"
            onChange={handleInputEvent}
            value={taxProfile?.altaDate || ""}
            name="altaDate"
            label={t("steps.irpf.altaLabel", "Alta Date (Registration Date)")}
            disabled={isLoading}
          />
        </>
      )}
    </div>
  );
};

export default IRPFStep;
